module.exports = __webpack_public_path__ + "img/features-split-image-02.0e30c93a.jpg";